import axios from "@/api/axiosInstance";

export function fetchSenderIds(pageNumber) {
  return axios.get(`/api/v1/senderids?page=${pageNumber}`);
}

export function requestSenderId(payload) {
  return axios.post(`/api/v1/requestsenderid`, payload);
}
